// This module is a singleton Params to keep the state during re-connects.

const Params = {
  data: {},

  set(namespace, key, value) {
    if (!this.data[namespace]) {
      this.data[namespace] = {};
    }

    this.data[namespace][key] = value;
  },

  get() {
    return this.data;
  },

  clear() {
    this.data = {};
  },
};

export default Params;
